export default "__VITE_ASSET__q70KP4w1__"